(function() {
  if (!window.theme || !window.theme.cart) return;

  var LEGACY_REQUIRED_CATEGORIES = ['Dres', 'Hlače', 'Dodatek'];
  var LEGACY_CODE_PROPERTY = '_alpe_bundle_discount_code';
  var V3_CODE_PROPERTY = '_alpe_bundle_v3_discount_code';
  var enforcementPromise = null;

  function routesRoot() {
    return window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
  }

  function lineProperties(line) {
    return line && line.properties && typeof line.properties === 'object'
      ? line.properties
      : {};
  }

  function uniqueList(value) {
    return String(value || '')
      .split(',')
      .map(function(item) { return item.trim(); })
      .filter(Boolean)
      .filter(function(item, index, items) { return items.indexOf(item) === index; });
  }

  function addTarget(group, line, version) {
    var properties = lineProperties(line);
    group.lines.push({
      version: version,
      bundleId: String(version === 'v3' ? properties._alpe_bundle_v3_id : properties._alpe_bundle_id),
      stageKey: String(properties._alpe_bundle_v3_stage_key || ''),
      category: String(properties.Kategorija || ''),
      variantId: String(line.variant_id || line.id || '')
    });
  }

  function getIncompleteBundleTargets(cart) {
    var items = cart && Array.isArray(cart.items) ? cart.items : [];
    var v3Groups = new Map();
    var legacyGroups = new Map();

    items.forEach(function(line) {
      if (Number(line.quantity || 0) < 1) return;

      var properties = lineProperties(line);
      var v3Id = properties._alpe_bundle_v3_id;
      var v3Code = properties[V3_CODE_PROPERTY];

      if (v3Id && v3Code) {
        if (!v3Groups.has(v3Id)) {
          v3Groups.set(v3Id, {
            stageKeys: new Set(),
            requiredCounts: new Set(),
            requiredKeySets: new Set(),
            lines: []
          });
        }

        var v3Group = v3Groups.get(v3Id);
        v3Group.stageKeys.add(String(properties._alpe_bundle_v3_stage_key || ''));
        v3Group.requiredCounts.add(Number(properties._alpe_bundle_v3_required_count || 0));
        v3Group.requiredKeySets.add(uniqueList(properties._alpe_bundle_v3_required_keys).join(','));
        addTarget(v3Group, line, 'v3');
        return;
      }

      var legacyId = properties._alpe_bundle_id;
      var legacyCode = properties[LEGACY_CODE_PROPERTY];
      if (!legacyId || !legacyCode) return;

      if (!legacyGroups.has(legacyId)) {
        legacyGroups.set(legacyId, { categories: new Set(), lines: [] });
      }

      var legacyGroup = legacyGroups.get(legacyId);
      legacyGroup.categories.add(String(properties.Kategorija || ''));
      addTarget(legacyGroup, line, 'legacy');
    });

    var targets = [];

    v3Groups.forEach(function(group) {
      var requiredCount = group.requiredCounts.size === 1
        ? Array.from(group.requiredCounts)[0]
        : 0;
      var requiredKeys = group.requiredKeySets.size === 1
        ? uniqueList(Array.from(group.requiredKeySets)[0])
        : [];
      var metadataValid = requiredCount >= 2
        && requiredCount <= 4
        && requiredKeys.length === requiredCount;
      var complete = metadataValid
        && group.lines.length === requiredCount
        && group.stageKeys.size === requiredCount
        && requiredKeys.every(function(stageKey) {
          return group.stageKeys.has(stageKey);
        });

      if (!complete) targets = targets.concat(group.lines);
    });

    legacyGroups.forEach(function(group) {
      var complete = LEGACY_REQUIRED_CATEGORIES.every(function(category) {
        return group.categories.has(category);
      });
      if (!complete) targets = targets.concat(group.lines);
    });

    return targets;
  }

  function findCurrentLine(cart, target) {
    var items = cart && Array.isArray(cart.items) ? cart.items : [];
    return items.find(function(line) {
      var properties = lineProperties(line);
      var matchesBundle = target.version === 'v3'
        ? String(properties._alpe_bundle_v3_id || '') === target.bundleId
          && String(properties._alpe_bundle_v3_stage_key || '') === target.stageKey
          && Boolean(properties[V3_CODE_PROPERTY])
        : String(properties._alpe_bundle_id || '') === target.bundleId
          && String(properties.Kategorija || '') === target.category
          && Boolean(properties[LEGACY_CODE_PROPERTY]);

      return matchesBundle
        && String(line.variant_id || line.id || '') === target.variantId;
    });
  }

  function updateLineWithoutBundleDiscount(line) {
    var properties = Object.assign({}, lineProperties(line));
    delete properties[V3_CODE_PROPERTY];
    delete properties[LEGACY_CODE_PROPERTY];

    return fetch(routesRoot() + 'cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: line.key,
        quantity: Number(line.quantity || 0),
        properties: properties
      })
    }).then(function(response) {
      if (!response.ok) throw new Error('Bundle integrity update failed');
      return response.json();
    });
  }

  function enforceBundleIntegrity(cart) {
    if (enforcementPromise) return enforcementPromise;

    enforcementPromise = Promise.resolve(cart || theme.cart.getCart())
      .then(function(currentCart) {
        var targets = getIncompleteBundleTargets(currentCart);
        if (!targets.length) return { cart: currentCart, changed: false };

        var workingCart = currentCart;
        var sequence = Promise.resolve();

        targets.forEach(function(target) {
          sequence = sequence.then(function() {
            var currentLine = findCurrentLine(workingCart, target);
            if (!currentLine) return;
            return updateLineWithoutBundleDiscount(currentLine).then(function(updatedCart) {
              workingCart = updatedCart;
            });
          });
        });

        return sequence.then(function() {
          return { cart: workingCart, changed: true };
        });
      })
      .finally(function() {
        enforcementPromise = null;
      });

    return enforcementPromise;
  }

  function refreshCartAfterIntegrity(result) {
    if (!result || !result.changed) return;
    document.dispatchEvent(new CustomEvent('cart:build'));
    document.dispatchEvent(new CustomEvent('cart:updated', {
      detail: { cart: result.cart, bundleIntegrityChecked: true }
    }));
  }

  function runInitialCheck() {
    theme.cart.getCart()
      .then(enforceBundleIntegrity)
      .then(refreshCartAfterIntegrity)
      .catch(function() {});
  }

  theme.cart.getIncompleteBundleTargets = getIncompleteBundleTargets;
  theme.cart.enforceBundleIntegrity = enforceBundleIntegrity;

  document.addEventListener('cart:updated', function(event) {
    if (event.detail && event.detail.bundleIntegrityChecked) return;
    enforceBundleIntegrity(event.detail && event.detail.cart)
      .then(refreshCartAfterIntegrity)
      .catch(function() {});
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runInitialCheck, { once: true });
  } else {
    runInitialCheck();
  }

  window.addEventListener('pageshow', runInitialCheck);
  document.addEventListener('visibilitychange', function() {
    if (document.visibilityState === 'visible') runInitialCheck();
  });
})();

